import type { PermissionGroup, userRole } from './types';
import { permissionGroupEnum, userRoleEnum } from './types';

export function hasPermission(group: PermissionGroup, role: userRole) {
  if (role === userRoleEnum.SYSTEM_ADMIN) {
    return true;
  }

  if (group === permissionGroupEnum.AGENT) {
    return role === userRoleEnum.AGENT;
  }

  if (group === permissionGroupEnum.UNDERWRITER) {
    return (
      role === userRoleEnum.UNDERWRITER ||
      role === userRoleEnum.UNDERWRITING_ADMIN
    );
  }

  if (group === permissionGroupEnum.UNDERWRITING_ADMIN) {
    return role === userRoleEnum.UNDERWRITING_ADMIN;
  }

  return false;
}
